export let PromocodeTypeEnum = /*#__PURE__*/function (PromocodeTypeEnum) {
  PromocodeTypeEnum["DISPOSABLE"] = "disposable";
  PromocodeTypeEnum["REUSABLE"] = "reusable";
  PromocodeTypeEnum["ONE_TIME_PER_ACCOUNT"] = "oneTimePerAccount";
  return PromocodeTypeEnum;
}({});
export let PromocodeMeasurementEnum = /*#__PURE__*/function (PromocodeMeasurementEnum) {
  PromocodeMeasurementEnum["ABSOLUTE"] = "absolute";
  PromocodeMeasurementEnum["PERCENTAGES"] = "percentages";
  return PromocodeMeasurementEnum;
}({});
export const PROMOCODE_TYPES = [{
  id: PromocodeTypeEnum.DISPOSABLE,
  label: 'Disposable'
}, {
  id: PromocodeTypeEnum.REUSABLE,
  label: 'Reusable'
}, {
  id: PromocodeTypeEnum.ONE_TIME_PER_ACCOUNT,
  label: 'One Time Per Account'
}];
export const MEASUREMENTS = [{
  value: PromocodeMeasurementEnum.PERCENTAGES,
  label: '%'
}, {
  value: PromocodeMeasurementEnum.ABSOLUTE,
  label: '$'
}];
const ADDITIONAL_DISCOUNT_SHIPPING = 'Shipping';
const ADDITIONAL_DISCOUNT_SETUP_FEE = 'Setup fee';
const ADDITIONAL_DISCOUNT_TAXFREE = 'Tax free';
export const IS_FREE_SHIPPING = 'IS_FREE_SHIPPING';
export const IS_FREE_SETUP_FEE = 'IS_FREE_SETUP_FEE';
export const IS_TAXFREE = 'IS_TAXFREE';
export const ADDITIONAL_DISCOUNTS = [{
  value: ADDITIONAL_DISCOUNT_SHIPPING,
  isSelected: false,
  type: IS_FREE_SHIPPING
}, {
  value: ADDITIONAL_DISCOUNT_SETUP_FEE,
  isSelected: false,
  type: IS_FREE_SETUP_FEE
}, {
  value: ADDITIONAL_DISCOUNT_TAXFREE,
  isSelected: false,
  type: IS_TAXFREE
}];
export const PROMOCODE_MAX_LENGTH = 20;
export const ADDITIONAL_DISCOUNT_TYPES = {
  [IS_FREE_SHIPPING]: IS_FREE_SHIPPING,
  [IS_FREE_SETUP_FEE]: IS_FREE_SETUP_FEE,
  [IS_TAXFREE]: IS_TAXFREE
};